
import proj4 from 'proj4';
const projectionList: { [code: string]: string } = {
    "EPSG:27700": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +no_defs",
    "EPSG:3857": "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs",
    "EPSG:4326": "+proj=longlat +datum=WGS84 +no_defs"
};



export function transformer(epsg_source: string, epsg_target: string): ((coordinates: [number, number]) => number[]) {
    proj4.defs([[epsg_source, projectionList[epsg_source]]]);
    proj4.defs([[epsg_target, projectionList[epsg_target]]]);

    let prj_source = proj4.defs(epsg_source);
    let prj_target = proj4.defs(epsg_target);

    // let p = proj4(prj_source, prj_target);
    let p = proj4(projectionList[epsg_source], projectionList[epsg_target]);

    return p.forward;
}

export function transform(coordinates: [number, number], epsg_source: string, epsg_target: string) {
    return transformer(epsg_source, epsg_target)(coordinates);
}

